import {ApolloClient, InMemoryCache} from "@apollo/client";
import {getAccessToken} from "./getAccessToken.js";


export const createApolloClient = () => {
    return new ApolloClient({
        cache: new InMemoryCache(),
        uri: `${process.env.REACT_APP_SDN_API_BASE_URL}`,
        headers: {authorization: `Bearer ${getAccessToken()}`,},
        name: 'sdn-office-ui'
    })
}
